import { atom } from 'jotai'

import { type DetailInfo } from '@/features/vehicle-dispatch-boards'

/**
 * ドラッグ中の配送依頼（再配車パターン）
 */
export const draggingDispatchDetailAtom = atom<DetailInfo | null>(null)

draggingDispatchDetailAtom.debugLabel = 'draggingDispatchDetailAtom'
